import React, { useMemo } from 'react';

import { Optimize } from '@totem/components/ticketing/optimizeTypes';
import Currency from '@totem/components/ui_components/widgets/currency/Currency';

type Props = {
  optimize: Optimize;
};

const OptimizeSavingsDisplay = ({ optimize }: Props) => {
  const timePeriod = useMemo(() => {
    return optimize.savingsTermPeriod
      .replace('Months', 'Month')
      .replace('Years', 'Year');
  }, [optimize.savingsTermPeriod]);

  const timePeriodPlural = useMemo(() => {
    if (optimize.savingsTerm > 1) {
      return timePeriod.replace('Month', 'Months').replace('Year', 'Years');
    }
    return timePeriod;
  }, [timePeriod, optimize.savingsTerm]);

  return (
    <span style={{ textAlign: 'left', display: 'block' }}>
      <Currency amount={optimize.savingsPotential} />
      <span style={{ paddingLeft: '.25em', paddingRight: '.25em' }}>per</span>
      {timePeriod}
      <span style={{ paddingLeft: '.25em', paddingRight: '.25em' }}>for</span>
      {optimize.savingsTerm} {timePeriodPlural}
    </span>
  );
};

export default OptimizeSavingsDisplay;
